import { useEffect, useState } from 'react';
import classNames from 'classnames';
import { useMediaQuery } from 'react-responsive';
import { useUserContext } from '@fff-web/fff-utilities';
import { rearrangeRoutes } from '../../helpers/navigationMenu';
import { buildUserInfoRequest } from '../../helpers/userAdapter';
import './Header.css';
import useFeatureFlagExperiment from '../../hooks/useFeatureFlagExperiment';
import { useGlobalNavTimerRedirect } from '../../hooks/useGlobalNavTimerRedirect';
import { useNavbarRoutes } from '../../hooks/useNavbarRoutes';
import { OPTIMIZELY_FEATURES_FLAGS } from '../../utils/configurations';
import { routes } from './constants';
import HeaderContent from './HeaderContent';

const Header = () => {
  const userRequest = buildUserInfoRequest(useUserContext().userInfo);
  const { isLoggedIn, lives, userInfo } = userRequest;
  const [isNavigationMenuVisible, setIsNavigationMenuVisible] = useState(false);

  useGlobalNavTimerRedirect(routes.fffSocialConfig);

  const isDesktop = useMediaQuery({
    query: '(min-width: 992px)',
  });

  useEffect(() => {
    setIsNavigationMenuVisible(false);
    document.body.classList.remove('scrollContain');
  }, [isDesktop]);

  const handleToggleNavigationMenuVisible = () => {
    if (!isDesktop) {
      setIsNavigationMenuVisible(!isNavigationMenuVisible);
      if (isNavigationMenuVisible) {
        document.body.classList.remove('scrollContain');
      } else {
        window.scroll({ top: 0, left: 0, behavior: 'smooth' });
        document.body.classList.add('scrollContain');
      }
    }
  };

  const [, , beautyEditBoxDecision] = useFeatureFlagExperiment(
    OPTIMIZELY_FEATURES_FLAGS.BEAUTY_EDIT_BOX_NAV,
  );

  const isBeautyEditBoxNavEnabled = beautyEditBoxDecision?.enabled;

  const { legacyLinks, userProfileData } = useNavbarRoutes(isBeautyEditBoxNavEnabled);

  const hasActiveBeautyEditBoxSubscription =
    userProfileData?.hasActiveBeautyEditBoxSubscription ?? false;
  const isShoppingClubUser = userProfileData?.isClubMember ?? false;

  const baseRoutes = legacyLinks ?? routes;

  const filteredRoutes = {
    ...baseRoutes,
    loginState: baseRoutes.loginState.map((route) => {
      if (route.id === 'my-box') {
        let newSubroutes = route.subRoutes;

        // Filter out customize for shopping club users
        if (isShoppingClubUser) {
          newSubroutes = newSubroutes.filter((subRoute) => subRoute.id !== 'customize');
        }

        // Update Beauty Edit Box route if user doesn't have a Beauty Edit Box subscription
        if (isBeautyEditBoxNavEnabled && !hasActiveBeautyEditBoxSubscription) {
          newSubroutes = newSubroutes.map((subRoute) => {
            if (subRoute.id === 'beauty-edit-box') {
              return {
                ...subRoute,
                route: '/product/fabfitfun-beauty-edit-box',
              };
            }
            return subRoute;
          });
        }

        return {
          ...route,
          subRoutes: isShoppingClubUser && newSubroutes.length === 1 ? [] : newSubroutes,
        };
      }

      return route;
    }),
  };

  return (
    <div
      className={classNames('header', {
        'is-navigation-menu-visible': isNavigationMenuVisible,
      })}
    >
      <div className="header__wrapper">
        <HeaderContent
          isLoggedIn={isLoggedIn}
          isDesktop={isDesktop}
          handleToggleNavigationMenuVisible={handleToggleNavigationMenuVisible}
          isNavigationMenuVisible={isNavigationMenuVisible}
          routes={rearrangeRoutes(
            filteredRoutes,
            lives,
            userInfo.subscriptionState,
            userInfo.subscriptionType,
          )}
          userInfo={userInfo}
        />
      </div>
    </div>
  );
};

Header.propTypes = {};

export default Header;
